import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const schedule = await fetch(`${URI_TARIFF_PLAN}tariff-schedule`, opts);
  const jsonResult = await schedule.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
